export default "__VITE_ASSET__6VxuiP34__"